import { openReportWithAuth, postForm } from "../util";
import { getCleApiPrefix } from "./client";
import axios from "axios";

export interface CreateInjunctionDecisionParams {
  userId: string;
  externalInjunctionId: string;
  file: File;
}

export interface GetInjunctionDecisionByInjunctionIdParams {
  userId: string;
  injunctionId: string;
}

export interface InjunctionDecisionModel {
  id: string;
}

const injunctionDecisionDownloadPath = ({
  userId,
  injunctionId,
}: GetInjunctionDecisionByInjunctionIdParams): string =>
  `${getCleApiPrefix()}users/${encodeURIComponent(
    userId,
  )}/injunction-decisions/by-injunction/${encodeURIComponent(
    injunctionId,
  )}/download`;

export const createInjunctionDecision = ({
  userId,
  externalInjunctionId,
  file,
}: CreateInjunctionDecisionParams): Promise<InjunctionDecisionModel> => {
  const formData = new FormData();
  formData.append("external_injunction_id", externalInjunctionId);
  formData.append("file", file);

  return postForm<InjunctionDecisionModel>({
    apiPrefix: getCleApiPrefix(),
    query: `users/${encodeURIComponent(userId)}/injunction-decisions`,
    body: formData,
  });
};

export const openInjunctionDecisionDownloadByInjunctionId = ({
  userId,
  injunctionId,
}: GetInjunctionDecisionByInjunctionIdParams): Promise<void> =>
  openReportWithAuth(injunctionDecisionDownloadPath({ userId, injunctionId }));

export const getInjunctionDecisionPdfBlobByInjunctionId = async ({
  userId,
  injunctionId,
}: GetInjunctionDecisionByInjunctionIdParams): Promise<Blob> => {
  const response = await axios.get<Blob>(
    injunctionDecisionDownloadPath({ userId, injunctionId }),
    { responseType: "blob" },
  );

  return response.data;
};
